import { useState } from 'react';
import { scrollToId, Cta } from './home-ui';

const NAV = [
    { label: 'What We Fix', href: 'help' },
    { label: 'Process', href: 'process' },
    { label: 'Services', href: 'services' },
    { label: 'Areas', href: 'areas' },
    { label: 'Guides', href: 'learn' },
    { label: 'FAQ', href: 'faq' },
];

/** Logo mark from the design: navy rounded square + orange dot. */
function LogoMark() {
    return (
        <span className="relative flex h-8 w-8 items-center justify-center rounded-lg bg-navy">
            <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-brand" />
        </span>
    );
}

export default function HomeHeader({ business = {} }) {
    const [mobileOpen, setMobileOpen] = useState(false);
    const { businessName = '', phone = '', email = '' } = business;
    const go = (id) => (e) => { e.preventDefault(); setMobileOpen(false); scrollToId(id); };

    return (
        <header className="sticky top-0 z-50 border-b border-surface-line bg-white/95 backdrop-blur">
            {/* Top bar */}
            <div className="hidden border-b border-surface-line/70 md:block">
                <div className="mx-auto flex max-w-[1200px] items-center justify-between px-6 py-1.5 text-sm text-ink-muted">
                    <div className="flex items-center gap-5">
                        <a href={`tel:${(phone || '').replace(/[^0-9+]/g, '')}`} className="hover:text-brand">✆ {phone}</a>
                        <a href={`mailto:${email}`} className="hover:text-brand">✉ {email}</a>
                    </div>
                    <div className="flex items-center gap-3 text-ink-faint">
                        <span className="hover:text-brand">f</span><span className="hover:text-brand">in</span><span className="hover:text-brand">ig</span>
                    </div>
                </div>
            </div>

            {/* Main nav */}
            <div className="mx-auto flex max-w-[1200px] items-center justify-between px-6 py-3">
                <a href="#top" onClick={go('top')} className="flex items-center gap-2.5">
                    <LogoMark />
                    <span className="font-display text-lg font-bold leading-none text-navy">
                        {businessName}
                    </span>
                </a>

                <nav className="hidden items-center gap-7 lg:flex">
                    {NAV.map((n) => (
                        <a key={n.href} href={`#${n.href}`} onClick={go(n.href)} className="text-sm font-medium text-ink hover:text-brand">{n.label}</a>
                    ))}
                </nav>

                <div className="flex items-center gap-3">
                    <Cta label="Free Review" href="#contact" className="!px-5 !py-2 text-sm" />
                    <button type="button" onClick={() => setMobileOpen((v) => !v)} className="text-2xl text-navy lg:hidden" aria-label="Menu">≡</button>
                </div>
            </div>

            {/* Mobile menu */}
            {mobileOpen && (
                <div className="border-t border-surface-line bg-white lg:hidden">
                    <nav className="mx-auto flex max-w-[1200px] flex-col px-6 py-3">
                        {NAV.map((n) => (
                            <a key={n.href} href={`#${n.href}`} onClick={go(n.href)} className="border-b border-surface-line/60 py-3 text-ink hover:text-brand">{n.label}</a>
                        ))}
                    </nav>
                </div>
            )}
        </header>
    );
}
